import React from "react";
import { View, StyleSheet } from "react-native";

import { mq } from "utils";
import { colors } from "asset/constant";

const ModalBar = () => <View style={styles.bar} />;
export default ModalBar;

const styles = StyleSheet.create({
  bar: {
    alignSelf: "center",
    width: mq(60),
    height: mq(5),
    marginTop: mq(10),
    borderRadius: mq(5),
    marginBottom: mq(20),
    backgroundColor: colors.text.placeholder,
  },
});
